import { LANGS } from "@/plugins/talentechFeed/locale";
import { TalentechSvgImages, useSvg } from "@talentech/components";
import * as countryCodes from "country-codes-list";
import type { CountryData } from "country-codes-list";

const languageOptions = Object.values(LANGS).map((lang) => ({
    label: lang,
    value: lang,
  }));
  

const getLanguageDetails = (lang: string): CountryData & {svg: string} => {
    const language = lang === "en" ? "gb" : lang;

    const code = countryCodes
    .filter("countryCode", language.toUpperCase())

    const llng = code.pop()
    const flagKey = `FLAGS_${llng?.countryCode.toUpperCase()}` as keyof typeof TalentechSvgImages;
    const svg = useSvg(TalentechSvgImages[flagKey]);
  
    // @ts-ignore
    return {
      svg,
      ...llng
    }
  }


  const getLanguageCode = (lang: string) => {
    const language = lang === "en" ? "gb" : lang;
    const code = countryCodes
    .filter("countryCode", language.toUpperCase())
    const llng = code.pop()
    return llng?.officialLanguageCode || lang;
  }

  export { getLanguageDetails, languageOptions, getLanguageCode };